var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqExpand = function SvgFaqExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 4809",
    fill: "#84fcfc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 15146",
    d: "M14.817 13.112V7.856h-1.632v5.256H7.953v1.632h5.232V20h1.632v-5.256h5.232v-1.632Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 15145",
    d: "M14 1a13 13 0 0 0-9.192 22.192A13 13 0 0 0 23.192 4.808 12.915 12.915 0 0 0 14 1m0-1A14 14 0 1 1 0 14 14 14 0 0 1 14 0Z"
  }))));
};
export default SvgFaqExpand;